import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { InstagramPanel } from '../components/InstagramPanel';
import { MapEmbed, directionsUrl } from '../components/MapEmbed';
import { useShopStatus } from '../hooks/useShopStatus';
import { useDocumentMeta } from '../lib/seo';
import { useI18n } from '../lib/i18n';
import { ShopStatusBadge } from '../components/ShopStatusBadge';

export function Home() {
  useDocumentMeta(
    'Nine80 Hair Studio | Walk-In Barbershop in Concord, NC',
    'Join the Nine80 Hair Studio walk-in list online or see current wait times before you arrive.',
  );
  const { status } = useShopStatus();
  const { t } = useI18n();

  return (
    <div>
      <section className="border-b border-border bg-gradient-to-b from-bg-elevated to-bg">
        <div className="mx-auto max-w-6xl px-4 py-16 sm:py-24 flex flex-col items-center text-center gap-6">
          <Logo className="h-28 w-auto sm:h-36" />
          <h1 className="text-4xl sm:text-6xl text-fg">Walk-Ins Welcome</h1>
          <p className="max-w-xl text-lg text-fg-muted">
            Skip the guesswork — join the Nine80 Hair Studio walk-in list from your phone before you
            head in.
          </p>
          {status && <ShopStatusBadge status={status} t={t} />}
          <div className="flex flex-col sm:flex-row gap-4 mt-2">
            <Link to="/check-in" className="btn-primary text-lg px-8">
              Join the Walk-In List
            </Link>
            <Link to="/location" className="btn-secondary text-lg px-8">
              Get Directions
            </Link>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-16 grid gap-10 sm:grid-cols-2">
        <div className="card">
          <h2 className="text-2xl mb-3">How walk-ins work</h2>
          <p className="text-fg-muted">
            Nine80 is a walk-in studio — no appointment required. Add yourself to the list online or
            in the shop, pick a barber or Next Available, and we'll be ready when you arrive.
          </p>
        </div>
        <div className="card">
          <h2 className="text-2xl mb-3">Prefer an appointment?</h2>
          <p className="text-fg-muted mb-4">Appointments are booked separately through Booksy.</p>
          <Link to="/book" className="btn-secondary">
            Book an Appointment
          </Link>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 pb-16 grid gap-10 sm:grid-cols-2">
        <InstagramPanel />
        <div className="space-y-4">
          <h2 className="text-2xl">Find us</h2>
          <MapEmbed />
          <a
            href={directionsUrl()}
            target="_blank"
            rel="noreferrer noopener"
            className="btn-secondary w-full"
          >
            Directions
          </a>
        </div>
      </section>
    </div>
  );
}
